// Signalement d'une session expiree (ex: 403 renvoye par le backend quand
// le jeton Google n'est plus valide - voir GoogleTokenFilter cote serveur)
// et reconnexion via le SSO Google.
//
// Login.tsx est le seul composant qui decide d'afficher l'ecran de
// connexion ou l'application ; il n'y a donc pas de store global partage.
// On utilise un evenement DOM comme petit bus applicatif : n'importe quel
// appel reseau (voir httpInterceptor.ts) peut signaler l'expiration sans
// avoir de reference directe vers Login.tsx.
export const SESSION_EXPIRED_EVENT = 'app:session-expired';

export function signalerSessionExpiree(): void {
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('user');
  window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
}
